export const v17Properties = [
  "orderNumber",

  // "productType",
  "deliveryType",
  "vehicleType",

  "date",
  "scheduledTime",
  "arrivalTimeTo",

  "senderName",
  "senderAddress",
  "senderBuildingNumber",
  "senderPhone",
  "senderEmail",
  "senderNote",

  "recipientName",
  "recipientAddress",
  "buildingNumber",
  "recipientPhone",
  "recipientEmail",
  "cashOnDeliveryAmount",
  "dropOffNote",

  "parcelValue",
  "parcelDimensions",

  "orderReferenceId",
]
